import { App } from '../App'
import CONST_SOCKET from '../const/socket'
import CONST_COMPONENT from '../const/component'
import { 
  createTriggerNode,
  createActionButtonNode 
} from './utils'

export class CreateDefaultComponent {
  constructor(params) {
    this.params = params

    if (! App.isInitialized) {
      throw new Error('Application has not been initialized yet.')
    }
  }

  async setupDefaultComponent() {
    throw new Error("This method has to be overridden by a subclass.")
  }
}

export class GetStartedComponent extends CreateDefaultComponent {
  async setupDefaultComponent() {
    const component = App.components.get(CONST_COMPONENT.POSTBACK)
    if (! component) {
      throw new Error(`Could not set up '${CONST_COMPONENT.POSTBACK}' component as default`)
    }

    App.defaultComponentName = CONST_COMPONENT.POSTBACK
    App.isDefaultComponentRegistered = true    

    const postbackComponentInstance = new component(App.config)
    const postbackNode = await postbackComponentInstance.createNode()
    postbackNode.position = [-200, -50]

    App.editor.addNode(postbackNode)
    App.defaultComponent = postbackNode

    const actionButtonNode = await createActionButtonNode()
    actionButtonNode.position = [-450, -50]
  
    App.editor.addNode(actionButtonNode)
  
    App.editor.connect(
      actionButtonNode.outputs.get(CONST_SOCKET.ACTION_BUTTON_OUTPUT),
      postbackNode.inputs.get(CONST_SOCKET.REFERENCE_INPUT_ACTION_BUTTON)
    )

    const defaultData = {
      selectedAction: this.params.action,
    }

    App.handleNodeData(actionButtonNode, App.editor, defaultData)
  }
}

export class KeywordComponent extends CreateDefaultComponent {
  async setupDefaultComponent() {
    const component = App.components.get(CONST_COMPONENT.POSTBACK)
    if (! component) {
      throw new Error(`Could not set up '${CONST_COMPONENT.POSTBACK}' component as default`)
    }

    App.defaultComponentName = CONST_COMPONENT.POSTBACK
    App.isDefaultComponentRegistered = true    

    const postbackComponentInstance = new component(App.config)
    const postbackNode = await postbackComponentInstance.createNode()
    postbackNode.position = [-200, -50]

    App.editor.addNode(postbackNode)
    App.defaultComponent = postbackNode

    const triggerNode = await createTriggerNode()
    triggerNode.position = [-450, -50]
  
    App.editor.addNode(triggerNode)
  
    App.editor.connect(
      triggerNode.outputs.get(CONST_SOCKET.TRIGGER_OUTPUT),
      postbackNode.inputs.get(CONST_SOCKET.REFERENCE_INPUT)
    )

    const defaultData = {
      // selectedAction: this.params.action,
    }

    App.handleNodeData(triggerNode, App.editor, defaultData)
  }
}

export class MessengerEngagementPluginComponent extends CreateDefaultComponent {
  async setupDefaultComponent() {
    const component = App.components.get(CONST_COMPONENT.POSTBACK)
    if (! component) {
      throw new Error(`Could not set up '${CONST_COMPONENT.POSTBACK}' component as default`)
    }

    App.defaultComponentName = CONST_COMPONENT.POSTBACK
    App.isDefaultComponentRegistered = true    

    const postbackComponentInstance = new component(App.config)
    const postbackNode = await postbackComponentInstance.createNode()
    postbackNode.position = [-200, -50]

    App.editor.addNode(postbackNode)
    App.defaultComponent = postbackNode

    const actionButtonNode = await createActionButtonNode()
    actionButtonNode.position = [-450, -50]
  
    App.editor.addNode(actionButtonNode)
  
    App.editor.connect(
      actionButtonNode.outputs.get(CONST_SOCKET.ACTION_BUTTON_OUTPUT),
      postbackNode.inputs.get(CONST_SOCKET.REFERENCE_INPUT_ACTION_BUTTON)
    )

    const defaultData = {
      selectedAction: this.params.action,
      selectedPlugin: this.params.plugin,
    }

    App.handleNodeData(actionButtonNode, App.editor, defaultData)
  }
}


